module.exports = __webpack_public_path__ + "img/ben.8c369570.jpg";